// src/lib/supabase.ts — the one Supabase client for the whole app.
//
// Coming from AWS, the mental model is roughly:
//   Cognito user pool          -> Supabase Auth (auth.users)
//   Cognito app client id      -> the anon key (public, ships in the bundle)
//   API Gateway JWT authorizer -> RLS policies evaluated inside Postgres
//   Lambda + pg per endpoint   -> supabase.from('table') / supabase.rpc()
//
// The important difference: there is no server of ours in the path. The browser
// talks to Postgres over HTTP with the user's JWT attached, and RLS is the only
// thing deciding what that JWT can see. That is why the schema's RLS policies
// are load-bearing and must never be disabled to make a query work.

import { createClient } from '@supabase/supabase-js';
import { supabaseAnonKey, supabaseUrl } from './env';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Keep the session in localStorage and refresh it in the background, so a
    // reload doesn't sign the user out mid-trip.
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'tabi.auth',
    // We use email + password only. No magic links, so there is no callback
    // URL to parse out of the address bar.
    detectSessionInUrl: false,
  },
});
